// extracted by mini-css-extract-plugin
export default {"container":"_BGDfI7QS6oOflvQeKPh","descriptionBlock":"LVdkHNNSJdtu6LveYXOA","coachSeatsBlock":"aFUdyJLcBDeGW5QFfQZ6","addSeatsButton":"h9Ow_FdKZ9LThjMdSHBg"};